import React from 'react';
import { Flex, Text, Box } from '@opendoor/bricks/core';
import { colors } from '@opendoor/bricks/theme/eero';
import { useDevice } from '@opendoor/bricks/hooks/useMedia';

type PromptProps = {
  title: string;
  body: string;
};

/**
 * Generic Prompt for Sell Direct
 * storybook-check-ignore
 * component-test-check-ignore
 */
export const Prompt: React.FC<PromptProps> = ({ title, body, children }) => {
  const { isMobile } = useDevice();
  return (
    <Flex
      p={7}
      borderRadius="roundedSquare"
      border={`1px solid ${colors.neutrals30}`}
      backgroundColor="neutrals0"
    >
      <Box fontSize={['s00', null, 's0']} lineHeight={['s00', null, 's0']}>
        <Text fontWeight="semibold" as="span">
          {title}
          {isMobile ? <br /> : ' '}
        </Text>
        <Text as="span">{body} </Text>
        {children}
      </Box>
    </Flex>
  );
};
